import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditStaffLazy = React.lazy(
	() => import(/* webpackChunkName : 'AddNewStaff' */ './components/EditStaff')
);

export default (store) => {
	return {
		path: 'staff-setup/:campusId?/edit-staff/:id',
		element: <AsyncLoading component={<EditStaffLazy />} />,
	};
};
